import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex items-center justify-center gap-2.5 bg-danger-100 py-3"
}
const _hoisted_2 = { class: "text-[13px] leading-xs text-base-500 font-medium" }

import Button from '../base/Button.vue';
import { AppConfigType } from '~src/admin/types';
import { inject } from 'vue';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionEnd',
  props: {
    endTime: {}
  },
  setup(__props: any) {

const { $gettext } = useGettext();

// Props
const props = __props;

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

// Get time in correct format
const trialEndTime = new Date(props.endTime).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
});

// Texts
const bannerText = isAccountFree ? $gettext('Your trial period will end on') : $gettext('Your subscription will end on');
const buttonText = isAccountFree ? $gettext('UPGRADE') : $gettext('RENEW SUBSCRIPTION');

return (_ctx: any,_cache: any) => {
  return (_ctx.endTime)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(bannerText)) + " " + _toDisplayString(_unref(trialEndTime)), 1),
        _createVNode(Button, {
          class: "rounded-full",
          text: _unref(buttonText),
          type: "secondary",
          size: "small"
        }, null, 8, ["text"])
      ]))
    : _createCommentVNode("", true)
}
}

})